/**
 * Created by Carsten Bühler
 * User: CBuehler on 13.11.2015
 * Copyright: xdot GmbH 2015
 */

'use strict';

import ReactDOM from 'external/react-dom';
import React from 'external/react';

import { AppContext } from 'plugin/liferay-widgets-react-web';

import NamedPropActions from './actions/NamedPropsActions';
import GroupSchemaActions from './actions/GroupSchemaActions';
import NamedListActions from './actions/NamedListActions';

import { getGroupSchemaStore, getNamedListStore, getNamedPropStore } from './stores/StoreFactory';
import { default as AssetLinkChangeRecordRenderer } from './components/ChangeRecords/AssetLinkChangeRecordRenderer';
import { default as GeoFeatureChangeRecordRenderer } from './components/ChangeRecords/GeoFeatureChangeRecordRenderer';
import {
    ClassNames,
    ElementTypes,
    EVENT_TYPE_CREATE,
    EVENT_TYPE_DELETE,
    EVENT_TYPE_UPDATE,
    GROUP_NAMED_LISTS,
    STORE_KEY_GROUP_SCHEMAS,
    UNITS,
} from './constants/Constants';
// WebApi
import { default as FliwasFileEntryWebApi } from './webapi/FliwasFileEntryWebApi';
import { default as NamedPropWebApi } from './webapi/NamedPropWebApi';
import { default as AssetTagWebApi } from './webapi/AssetTagWebApi';
import { default as UploadWebApi } from './webapi/UploadWebApi';
import { default as ReferenceValueWebApi } from './webapi/ReferenceValueWebApi';
import { default as GroupSchemaWebApi } from './webapi/GroupSchemaWebApi';
import { default as NamedListWebApi } from './webapi/NamedListWebApi';
import { default as BomListWebApi } from './webapi/BomListWebApi';
import { default as FliwasPermissionWebApi } from './webapi/FliwasPermissionWebApi';

import InitialNamedProps from 'external/json!named-props';
import ModalRenderer from './controllerViews/ModalRenderer';
//Utils
import * as DateFormat from './utils/date-format.js';
import * as FormValidationUtil from './utils/form-validation-util';
import InitialGroupSchemas from 'external/json!group-schemas';
import InitialNamedLists from 'external/json!initial-named-lists';
import WebcamJournalRenderer from './components/WebcamJournalRenderer';

export * from './stores/StoreFactory';
export * from './utils/timeseriesevent-util';
export * from './components/ChangeRecords/TableElems';

export {
    ClassNames,
    ElementTypes,
    STORE_KEY_GROUP_SCHEMAS,
    EVENT_TYPE_CREATE,
    EVENT_TYPE_DELETE,
    EVENT_TYPE_UPDATE,
    UNITS
};

export { AssetTagWebApi };
export { FliwasFileEntryWebApi };
export { NamedPropWebApi };
export { ReferenceValueWebApi };
export { GroupSchemaWebApi };
export { NamedListWebApi };
export { BomListWebApi };
export { UploadWebApi };
export { FliwasPermissionWebApi };

AppContext.registerBundle({
    webApis: {
        AssetTagWebApi,
        FliwasFileEntryWebApi,
        NamedPropWebApi,
        NamedListWebApi,
        BomListWebApi,
        ReferenceValueWebApi,
        GroupSchemaWebApi,
        UploadWebApi,
        FliwasPermissionWebApi
    },
    detailsRenderer: {}
});

export const AssetLink = undefined;
export const AssetTag = undefined;
export const DLFileEntry = undefined;
export const Group = undefined;
export const ChangeRecordRenderer_DLFileEntry = AssetLinkChangeRecordRenderer;
export const ChangeRecordRenderer_AssetLink = AssetLinkChangeRecordRenderer;
export const ChangeRecordRenderer_GeoFeature = GeoFeatureChangeRecordRenderer;
export const JournalRenderer_Webcam = WebcamJournalRenderer;

export { default as BaseRemoteDataLayerController } from './map/BaseRemoteDataLayerController';
export { default as BaseRemoteVectorLayerController } from './map/BaseRemoteVectorLayerController';
export { default as WmsLayerRefreshController } from './map/WmsLayerRefreshController';

export { default as ModalActions } from './actions/ModalActions';
export { default as ReferenceValueActions } from './actions/ReferenceValueActions';
export { default as FliwasPermissionActions } from './actions/FliwasPermissionActions';
export { GroupSchemaActions };

//Components
export { default as ReferenceValueSelect } from './components/ReferenceValueSelect';
export { default as DateTimeDisplay } from './components/DateTimeDisplay';
export { default as NumberSelect } from './components/NumberSelect';
export { FilterDropdown } from './components/FilterDropdown';
export { BaseToolbar } from './components/BaseToolbar';
export { ActiveFilterBar } from './components/ActiveFilterBar';
export { default as TimeLineItem } from './components/ChangeRecords/TimeLineItem';
export { default as TimeLineItemMessageHeader } from './components/ChangeRecords/TimeLineItemMessageHeader';
export { default as NamedProp } from './components/NamedProp';
export { default as ObjectDates } from './components/ObjectDates';
export { default as BusinessObjectLink } from './components/BusinessObjectLink';
export * from './components/MiniWidgetComponents';
export * from './components/DetailsRenderer';
export * from './components/DetailsListItemComponents';
export { default as MultilineText } from './components/MultilineText';
export { default as Icon } from './components/Icon';
export { default as Upload } from './components/Upload';
export { default as HighChartsChart } from './charts/HighChartsChart';
export { default as HCTimeSeriesPlugin } from './charts/plugins/HCTimeSeriesPlugin';
export { default as C3TimeSeriesPlugin } from './charts/plugins/TimeSeriesPlugin';  /* @deprecated */
export { default as DateTimePicker } from './components/DateTimePicker';
export { default as DateRangePicker } from './components/DateRangePicker';
export { default as ImageDisplay } from './components/ImageDisplay';
export { default as BusinessObjectSelect } from './components/BusinessObjectSelect';
export { default as AssetLinkChooser } from './components/AssetLinkChooser';
export { default as ItemDescription } from './components/ItemDescription';
export { default as AttachedDocumentList } from './components/AttachedDocumentList';
export { default as AttachedObjectList } from './components/AttachedObjectList';
export { AttachedFileListItem as AttachedFileListItem } from './components/AttachedDocumentList';
export { default as AttachedDocumentsByTagForm } from './components/AttachedDocumentsByTagForm';
export { default as BusinessObjectMultiSelect } from './components/BusinessObjectMultiSelect';
export { JournalEntryAddForm } from './components/JournalEntryAddForm';
export { PDFExportButton } from './components/PDFExportButton';
export { default as SituationStatusIcons } from './components/SituationStatusIcons';
export * from './components/BasicFormComponents';
export * from './components/InlineFormControl';
export { default as InlineDescriptionFormControl } from './components/InlineDescriptionFormControl';
export { default as InlinePositionFormControl } from './components/InlinePositionFormControl';
export { default as FliwasObjectMasterDetailList } from './components/FliwasObjectMasterDetailList';
export { default as FliwasObjectMasterDetailPosition } from './components/FliwasObjectMasterDetailPosition';
export { default as SelectObjectErrorMessage } from './components/SelectObjectErrorMessage';
export { default as FliwasDetailsBox } from './components/FliwasDetailsBox';
export { default as FliwasActionButtons } from './components/FliwasActionButtons';
export { default as JournalAddEntryButton } from './components/JournalAddEntryButton';
export { DefaultChangeRecordListItem } from './components/ChangeRecords/DefaultChangeRecordListItem';
export { ChangeRecordTextRenderer } from './components/ChangeRecords/ChangeRecordTextRenderer';
export { ChangeRecordDateRenderer } from './components/ChangeRecords/ChangeRecordDateRenderer';
export { DefaultChangeRecordTable } from './components/ChangeRecords/DefaultChangeRecordTable';
export { DefaultTimeLineItemMessageHeader } from './components/ChangeRecords/DefaultTimeLineItemMessageHeader';
export { ChangeRecordBooleanRenderer } from './components/ChangeRecords/ChangeRecordBooleanRenderer';
export { ChangeRecordDescriptionRenderer } from './components/ChangeRecords/ChangeRecordDescriptionRenderer';
export { ChangeRecordGeometryRenderer } from './components/ChangeRecords/ChangeRecordGeometryRenderer';
export { ChangeRecordBusinessObjectRenderer } from './components/ChangeRecords/ChangeRecordBusinessObjectRenderer';
export { ChangeRecordSiteTeamRenderer } from './components/ChangeRecords/ChangeRecordSiteTeamRenderer.jsx';
export { HtmlTextRenderer } from './components/ChangeRecords/HtmlTextRenderer';
export { Accordion } from './components/Accordion';

export { default as assetLink } from './utils/assetLink';
export { default as getGroupSchemaProperties } from './utils/group-schema-util';
export { default as uploadFile } from './utils/uploadFile';
export { default as timeseriesUtil } from './utils/timeseries-util.js';
export { default as formatMeasurements } from './utils/formating-util.js';
export { METRIC_TYPE } from './utils/timeseries-util.js';
export * from './utils/event-type-util';
export { hasEditPermissionAndGroup } from './utils/editPermissionUtil';

// Widgets
export { default as WebCamWidget } from './widgets/WebCamWidget';
export { default as DetailsWidget } from './widgets/DetailsWidget';
export { default as FliwasMapWidget } from './widgets/FliwasMapWidget';
export { default as NamedListMasterDetailsWidget } from './widgets/NamedListMasterDetailsWidget';
export { default as BomListWidget } from './widgets/BomListWidget';

export { DateFormat };

export { FormValidationUtil };

window.waitForElementById('fliwas-modal-container',
// eslint-disable-next-line react/no-render-return-value
    e => ReactDOM.render(React.createElement(ModalRenderer, { hasConfig: false }), e));

const NamedPropStore = getNamedPropStore(AppContext);
NamedPropActions.list(InitialNamedProps); //early load
if (!NamedPropStore.getProps()) console.error('Props not initialized');

const GroupSchemaStore = getGroupSchemaStore(AppContext);
GroupSchemaActions.listDefaultGroupSchemas(InitialGroupSchemas); //early load
if (!GroupSchemaStore.getProps()) console.error('GroupSchemas not initialized');

const NamedListStore = getNamedListStore(AppContext);
NamedListActions.initialNamedLists(InitialNamedLists); //early load
if (!NamedListStore.getRemoteData(GROUP_NAMED_LISTS)) console.error('NamedLists not initialized');

Liferay.Util.Session.get('com.liferay.product.navigation.product.menu.web_productMenuState').then(function(v) {
    Liferay.Util.Session.set('com.liferay.product.navigation.product.menu.web_productMenuState', 'closed');
});



// WEBPACK FOOTER //
// ./js/base-portlet.js